import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import DropzoneComponent from "react-dropzone-component";
import ProcessUploadXhr from "../../utils/ProcessUploadXhr";
import MongoObjectID from "../../utils/MongoObjectID";
import { baseUri } from "../../client";

class UploadImage extends Component {
  constructor(props) {
    super(props);

    let images = [];
    if (props.images) {
      images = props.images.map(i => ({
        id: i.id || MongoObjectID(),
        url: i.url
      }));
    }

    this.state = {
      images,
      zoneConfig: {
        ...props.zoneConfig,
        maxFiles: props.limit > 0 ? props.limit : null,
        dictFileTooBig: "Archivo demasiado pesado"
      }
    };

    this.dropzoneRef = null;
    this.imageEventHandler = {
      init: this.onInit,
      complete: () => this.props.onTouched(true),
      sending: ProcessUploadXhr,
      removedfile: this.removeUploadedImage.bind(this),
      success: this.successImageUpload.bind(this),
      addedfile: this.onAddedFile
    };

    this.props.onChange(images);
  }

  componentDidUpdate = prevProps => {
    if (
      (prevProps.images === null && this.props.images !== null) ||
      prevProps.images.length !== this.props.images.length
    ) {
      const remapImages = this.props.images.map(i => ({
        id: MongoObjectID(),
        url: i && i.url
      }));
      this.setState({
        images: remapImages
      });
      const files = this.props.images.map(i => ({
        id: i.id || MongoObjectID(),
        url: i.url
      }));
      this.props.onChange(files);
    }
  };

  onAddedFile = file => {
    if (file.size > 1024 * 1024) {
      this.dropzoneRef.dropzone.removeFile(file);
      this.setState({ error: "Archivo demasiado pesado" });
      this.props.onTouched(true);
    }
    if (this.props.limit > 0 && this.state.images.length >= this.props.limit) {
      this.dropzoneRef.dropzone.removeFile(file);
      this.setState({
        error: `El limite de archivos subidos es de ${this.props.limit}`
      });
      this.props.onTouched(true);
    }
  };

  successImageUpload(file, response) {
    console.log("success upload", file);
    const images = this.state.images.slice() || [];
    images.push({
      id: MongoObjectID(),
      file,
      url: response.location
    });
    this.setState({ images }, this.notifyChange);
  }

  notifyChange = () => {
    const images = this.state.images.map(i => ({
      url: i.url
    }));
    this.props.onTouched(true);
    this.props.onChange(images);
  };

  removeUploadedImage(file) {
    if (file.xhr) {
      const urlToRemove = JSON.parse(file.xhr.response).location;

      // TODO: Remove file from cloudinary
      const images = this.state.images.filter(
        image => image.url !== urlToRemove
      );
      this.setState({ images }, this.notifyChange);
    }
  }

  removeImage(e, img) {
    e.preventDefault();

    let images = [...this.state.images];
    images = images.filter(i => i.id !== img.id);

    if (img.file) {
      const { file } = img;
      this.dropzoneRef.dropzone.removeFile(file);
    }

    this.setState({ images }, this.notifyChange);
  }

  renderCurrentImages() {
    return (
      <Fragment>
        {this.state.images.map(image => (
          <div
            className="col-lg-3 col-md-4 col-xs-6"
            key={image.id || image.url}
          >
            <div className="d-block mb-4 h-100 current-image-item">
              <img className="img-fluid img-thumbnail" src={image.url} alt="" />
              <button
                onClick={e => this.removeImage(e, image)}
                className="delete-image-span"
              >
                <i className="fa fa-trash" />
              </button>
            </div>
          </div>
        ))}
      </Fragment>
    );
  }

  render() {
    const { error } = this.props;
    return (
      <Fragment>
        {this.props.bigTitle ? (
          <h2 className="m-b-sm">{this.props.title}</h2>
        ) : (
          <label>{this.props.title}</label>
        )}
        <div className="description-label">
          Las imágenes deben ser de 1440x1000 y máximo 1 Mb de peso
        </div>
        <DropzoneComponent
          ref={ref => {
            this.dropzoneRef = ref;
          }}
          config={this.props.config}
          djsConfig={this.state.zoneConfig}
          eventHandlers={this.imageEventHandler}
          className={`dropzone dropzone-design ${
            error ? "dz-error-border" : ""
          }`}
        >
          {(!this.dropzoneRef ||
            (this.dropzoneRef &&
              this.dropzoneRef.dropzone.files.length === 0)) && (
            <div className="dz-default dz-message">
              <div>
                Arrastra una imagen
                <br /> o haz click para agregar
              </div>
            </div>
          )}
        </DropzoneComponent>
        {(error || this.state.error) && (
          <span className="input-text-error-msg">
            {error || this.state.error}
          </span>
        )}

        {this.state.images && this.state.images.length > 0 && (
          <div className="current-images-wrap">
            <h4 className="my-4">Imágenes actuales</h4>
            <div className="row text-center current-images">
              {this.renderCurrentImages()}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

UploadImage.defaultProps = {
  touched: false,
  error: undefined,
  config: {
    iconFiletypes: [".jpg", ".png", ".jpeg", ".gif"],
    showFileTypeIcon: true,
    postUrl: `${baseUri}/upload`
  },
  zoneConfig: {
    paramName: "file",
    acceptedFiles: "image/jpeg,image/png,image/gif",
    addRemoveLinks: true,
    dictRemoveFile: "Quitar imagen",
    dictRemoveFile: "Quitar archivo",
    dictDefaultMessage: "Arrastra archivos aquí para subirlos",
    dictFallbackMessage: "Tu navegador no soporta el arrastre de archivos.",
    dictFallbackText:
      "Por favor utiliza el siguiente formulario para subir tus archivos.",
    dictFileTooBig:
      "Archivo demasiado grande ({{filesize}}MiB). Tamaño máximo: {{maxFilesize}}MiB.",
    dictInvalidFileType: "No puedes subir este tipo de archivo.",
    dictResponseError: "Error de servidor: {{statusCode}}.",
    dictCancelUpload: "Cancelar subida",
    dictCancelUploadConfirmation:
      "¿Estás seguro que deseas cancelar esta carga?",
    dictRemoveFile: "Quitar archivo",
    dictRemoveFileConfirmation: null,
    dictMaxFilesExceeded: "No puedes subir más archivos."
  },
  onTouched: () => {},
  onChange: () => {},
  images: [],
  bigTitle: false,
  title: "Imágenes"
};

UploadImage.propTypes = {
  touched: PropTypes.bool,
  error: PropTypes.string,
  zoneConfig: PropTypes.object,
  config: PropTypes.object,
  onTouched: PropTypes.func,
  onChange: PropTypes.func,
  images: PropTypes.array,
  bigTitle: PropTypes.bool,
  title: PropTypes.string
};

export default UploadImage;



// WEBPACK FOOTER //
// ./src/components/UploadImages/index.js